import { useCallback, useRef } from 'react';
import { rootContainer } from 'app/shadowRoot';

import useLastReadMessageIndex from './useLastReadMessageIndex';
import useLastMessageIndex from './useLastMessageIndex';

export default function useScrollDown<T extends HTMLElement>() {
  const ref = useRef<T>(null);
  const { lastReadMessageIndex } = useLastReadMessageIndex();
  const lastMessageIndex = useLastMessageIndex();

  const scrollToIndex = useCallback((index: number) => {
    ref.current?.setAttribute('data-programmatic-scroll', 'true');

    setTimeout(() => {
      const messageElement = rootContainer.querySelector(`[data-message-index="${index}"]`);

      messageElement?.scrollIntoView({
        block: 'end',
      });
    });

    setTimeout(() => {
      ref.current?.removeAttribute('data-programmatic-scroll');
    }, 2000);
  }, []);

  const scrollDown = useCallback(() => {
    const toIndex = lastMessageIndex > lastReadMessageIndex ? lastReadMessageIndex + 1 : lastReadMessageIndex;

    scrollToIndex(toIndex);
  }, [lastMessageIndex, lastReadMessageIndex, scrollToIndex]);

  return { ref, scrollDown, scrollToIndex };
}
